$(document).ready(function(){

	$('#btn-navbar-pages-2').on('click', function(e){

	$('.slice-orders-none').parent().attr('class','');



	});

//	$('#atualizaLogin1').on('click', function(e){
//
//		setaLogin1();
//

//	});
  
 function setaLogin1() {
//	alert("SETA LOGIN CLICK");  
//  document.getElementById("setaLoginCanvas").click();
//	alert("SETA LOGIN SUBMIT");  
  
// 	document.getElementById("login_form").submit();  

  
/*   
  usuario = $("#customerId").val();
        email = encodeURI($("#input-email").val());
  		
        if ($("#input-senhaNova").val()){
	        senha = $("#input-senhaNova").val();          
        }else{
	        senha = $("#input-senhaAtual").val();          
        }
      
        var url = "https://localhost/igti/Integracao/acessa_canvas/" + usuario + "/" + email + "/" + senha ;
        $.ajax({
            type: "POST",
            url: url,
            data: "",
            dataType: "json",
            success: function (response)
            {
              console.log("RETORNEI ATUALIZACAO", response);
            },
            error: function (error) {
                console.log(error);
            }
        }).done(function (value) {

        });
    */
        
    }
  //setaLogin1();
  
});


